var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7507 14.75H31.2507C31.4938 14.75 31.7269 14.8466 31.8988 15.0185C32.0707 15.1904 32.1673 15.4236 32.1673 15.6667V30.3333C32.1673 30.5764 32.0707 30.8096 31.8988 30.9815C31.7269 31.1534 31.4938 31.25 31.2507 31.25H14.7507C14.5075 31.25 14.2744 31.1534 14.1025 30.9815C13.9306 30.8096 13.834 30.5764 13.834 30.3333V15.6667C13.834 15.4236 13.9306 15.1904 14.1025 15.0185C14.2744 14.8466 14.5075 14.75 14.7507 14.75V14.75ZM30.334 18.6348L23.0667 25.1432L15.6673 18.6147V29.4167H30.334V18.6348ZM16.1357 16.5833L23.0566 22.6902L29.8775 16.5833H16.1357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f5ea413279bfd54d7d085abf8876da68.svg";
export { ForwardRef as ReactComponent };